const styles = {
  page: {
    padding: "32px 50px",
    background: "#f8fafc",
    minHeight: "100vh",
    fontFamily: "Inter, sans-serif",
  },

  heading: {
    fontSize: 26,
    fontWeight: 800,
    marginBottom: 10,
    color: "#0f172a",
  },

  progress: {
    fontSize: 13,
    color: "#475569",
    marginBottom: 18,
  },

  center: {
    textAlign: "center",
    marginTop: 50,
  },

  card: {
    background: "#fff",
    borderRadius: 18,
    padding: 26,
    marginBottom: 20,
    border: "1px solid #e5e7eb",
    boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
  },

  question: {
    fontSize: 15,
    lineHeight: 1.6,
    color: "#020617",
  },

  statusRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    marginTop: 14,
    alignItems: "center",
  },

  badgeRow: {
    display: "flex",
    gap: 8,
    marginLeft: "auto",
    flexWrap: "wrap",
  },

  badge: {
    padding: "6px 12px",
    borderRadius: 999,
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
  },

  statusPill: {
    padding: "6px 12px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 600,
  },

  miniBox: {
    background: "#f1f5f9",
    padding: "6px 12px",
    borderRadius: 999,
    fontSize: 12,
  },

  infoBox: {
    background: "#fef9c3",
    padding: "10px 14px",
    borderRadius: 10,
    marginTop: 14,
    fontSize: 13,
  },

  block: {
    marginTop: 18,
  },

  blockTitle: {
    fontSize: 12,
    fontWeight: 700,
    color: "#475569",
    marginBottom: 6,
    textTransform: "uppercase",
  },

  blockBody: {
    background: "#020617",
    color: "#22c55e",
    padding: 14,
    borderRadius: 10,
    fontSize: 12,
    whiteSpace: "pre-wrap",
    lineHeight: 1.5,
  },

  sectionTitle: {
    fontSize: 13,
    fontWeight: 700,
    marginTop: 20,
  },

  optionsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 10,
    marginTop: 10,
  },

  option: {
    background: "#ecfeff",
    borderRadius: 10,
    padding: 12,
    fontSize: 12,
  },

  divider: {
    margin: "22px 0",
    borderColor: "#e5e7eb",
  },

  navBar: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
  },

  navBtn: {
    padding: "12px 26px",
    borderRadius: 10,
    border: "none",
    cursor: "pointer",
    fontWeight: 700,
    background: "#6366f1",
    color: "#fff",
  },
  headerBar: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 16,
  flexWrap: "wrap",
  marginBottom: 20,
},

headerActions: {
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
},

headerBtn: {
  padding: "10px 16px",
  borderRadius: 10,
  border: "none",
  cursor: "pointer",
  fontWeight: 700,
  background: "#6366f1",
  color: "#fff",
  fontSize: 13,
  whiteSpace: "nowrap",
  transition: "0.2s ease",
},
};

export default styles;